//
// THIS FILE IS DEPRECATED AND WILL BE REMOVED
// Update ./constants file instead
//
import { MAP_STYLES } from './constants';

export default MAP_STYLES;
